import React, { useEffect } from "react";
import { useSelector } from "react-redux";

export const TotalTimerCard = ({ title, type }) => {
  const initialTimeInSeconds = useSelector(
    (state) => state.assessment.totalTime
  );
  const [seconds, setSeconds] = React.useState(initialTimeInSeconds);

  const onTimeUp = React.useCallback(() => {
    //router.push("/review");
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((curr) => curr - 1);
      if (seconds === 0) {
        onTimeUp();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, onTimeUp]);

  const strokeDashoffset =
    (seconds / initialTimeInSeconds) * (2 * Math.PI * 45);

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const getProgressColor = (seconds, initialTimeInSeconds) => {
    const percentageTimeLeft = (seconds / initialTimeInSeconds) * 100;
    if (percentageTimeLeft > 50) {
      return type === 2 ? "text-green-300" : "text-blue-300";
    } else if (percentageTimeLeft > 20) {
      return "text-yellow-300";
    } else if (percentageTimeLeft > 10) {
      return "text-orange-300";
    } else {
      return "text-red-300";
    }
  };

  const getPathColor = (seconds, initialTimeInSeconds) => {
    const percentageTimeLeft = (seconds / initialTimeInSeconds) * 100;
    if (percentageTimeLeft > 50) {
      return type === 2 ? "text-green-100" : "text-blue-100";
    } else if (percentageTimeLeft > 20) {
      return "text-yellow-100";
    } else if (percentageTimeLeft > 10) {
      return "text-orange-100";
    } else {
      return "text-red-100";
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-full p-4 bg-white rounded-lg shadow-md">
      <svg
        className={`w-24 h-24 transform rotate-90 ${getProgressColor(
          seconds,
          initialTimeInSeconds
        )}`}
        viewBox="0 0 100 100"
      >
        <circle
          className={`stroke-current ${getPathColor(
            seconds,
            initialTimeInSeconds
          )}`}
          fill="none"
          strokeWidth="10"
          strokeDasharray={2 * Math.PI * 45}
          strokeDashoffset="0"
          cx="50"
          cy="50"
          r="45"
        />
        <circle
          className="stroke-current"
          fill="none"
          strokeWidth="10"
          strokeDasharray={2 * Math.PI * 45}
          strokeDashoffset={strokeDashoffset}
          cx="50"
          cy="50"
          r="45"
        />
      </svg>
      <div className="text-gray-800 text-center ">
        <h1 className="text-2xl font-bold mb-2">{formatTime(seconds)}</h1>
        <h2 className="text-xl">{title}</h2>
      </div>
    </div>
  );
};
